import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { ChipButton, Typography } from 'seagull';
import { DropdownMenu } from 'seagull/components/DropdownMenu';
import { Archive, ChevronDown, ChevronUp, Import, Trash } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import styles from './ClientsBulkActions.module.scss';
export const GetClientsBulkActionsTID = (parentTestId)=>getTestIds(parentTestId);
export const ClientsBulkActions = (param)=>{
    let { numSelected, onArchive, onDelete, onExport, exporting = false, testId } = param;
    const { t: bulkTexts } = useLocaleKeys('pages.clientsDashboard.bulkActions');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { ClientsBulkActionsTID: TID } = useMemo(()=>GetClientsBulkActionsTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                className: styles.selectedItems,
                testId: TID.Counter(),
                children: numSelected > 0 ? bulkTexts.selectedCount({
                    count: numSelected
                }) : ''
            }),
            /*#__PURE__*/ _jsxs(DropdownMenu, {
                onOpenChange: setIsMenuOpen,
                target: /*#__PURE__*/ _jsx(ChipButton, {
                    bi: {
                        name: 'clients_bulk_actions_dropdown'
                    },
                    testId: TID.Trigger(),
                    suffixIcon: isMenuOpen ? /*#__PURE__*/ _jsx(ChevronUp, {}) : /*#__PURE__*/ _jsx(ChevronDown, {}),
                    highlight: isMenuOpen,
                    disabled: numSelected === 0,
                    children: bulkTexts.label()
                }),
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                        intent: Intent.ExportClientsToCsv,
                        bi: {
                            name: 'clients_bulk_export_csv'
                        },
                        iconStart: /*#__PURE__*/ _jsx(Import, {}),
                        testId: TID.Export(),
                        disabled: exporting,
                        onClick: onExport,
                        children: bulkTexts.export()
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                        bi: {
                            name: 'clients_bulk_archive'
                        },
                        iconStart: /*#__PURE__*/ _jsx(Archive, {}),
                        testId: TID.Archive(),
                        onClick: onArchive,
                        children: bulkTexts.archive()
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                        bi: {
                            name: 'clients_bulk_delete'
                        },
                        iconStart: /*#__PURE__*/ _jsx(Trash, {
                            size: 20
                        }),
                        testId: TID.Delete(),
                        skin: "error",
                        onClick: onDelete,
                        children: bulkTexts.delete()
                    })
                ]
            })
        ]
    });
};
